var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6V24H4V0H16L22 6ZM5 23H21V7H15V1H5V23ZM16 6H20.5L16 1.5V6Z",
    fill: "#040404"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 24,
    height: 9,
    rx: 1,
    fill: "#C600C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 15C6.88071 15 8 16.1193 8 17.5C8 18.8807 6.88071 20 5.5 20C4.11929 20 3 18.8807 3 17.5C3 16.1193 4.11929 15 5.5 15ZM5.5 16C4.67157 16 4 16.6716 4 17.5C4 18.3284 4.67157 19 5.5 19C6.32843 19 7 18.3284 7 17.5C7 16.6716 6.32843 16 5.5 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.001C15 18.5 15.3471 19 16 19C16.6529 19 17 18.5 17 18V15H18V18C18 19.5 17.2098 20 16 20C14.7902 20 14 19.5 14 18V15H15V18.001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1436 15C21.7645 15.0018 22.3542 15.1693 22.8662 15.5186L22.4629 16.502C22.0525 16.2593 21.6222 16.067 21.1348 16.0654C20.8863 16.0647 20.302 16.0663 20.3008 16.4326C20.3006 16.5606 20.3914 16.6711 20.6035 16.7705C20.8086 16.8665 21.0544 16.9171 21.2393 16.9629C21.5866 17.0441 22.0202 17.1576 22.3662 17.376C22.7218 17.6007 23.0015 17.9487 23 18.4834C22.9981 19.0504 22.694 19.4384 22.2969 19.6748C21.9066 19.907 21.418 20.0012 20.9951 20C20.2573 19.9979 19.5635 19.8049 19 19.3203L19.4434 18.332C19.9003 18.6941 20.3991 18.9327 20.9971 18.9346C21.3233 18.9356 21.5125 18.8857 21.6152 18.8193C21.901 18.6342 21.6547 18.3294 21.4385 18.2285C21.2325 18.1325 20.9858 18.0828 20.7979 18.0361C20.4467 17.9517 20.037 17.8448 19.7168 17.6289C19.3275 17.3663 19.1685 16.975 19.1455 16.5234C19.1472 15.9569 19.4456 15.5667 19.8408 15.3281C20.2291 15.0938 20.7172 14.9989 21.1436 15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9834 15C12.1321 15.004 13 15.4498 13 16.9981C13 18.4981 11.99 19.0133 10.9434 19.0098H9.98047V19.9883L9 19.9922L9.0127 15H10.9834ZM9.98047 17.9981H11C11.7098 18.0004 11.9983 17.6351 12 16.9981C12.0017 16.3611 11.7097 16.0003 11 15.9981H10L9.98047 17.9981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpus);
export default __webpack_public_path__ + "static/media/opus.0bf03df9e33a4097346701f9a09b3d99.svg";
export { ForwardRef as ReactComponent };